import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import {
  jwtApiClient,
  jwtApiClientFile,
} from "@/apps/merchant3/services/apiClient/apiClient";

export interface ICartTagWrap {
  cartTag: string;
}

export const uploadIdentificationImage = async (
  cartTag: string,
  file: FormData,
  type: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClientFile.post(
    M3_API(cartTag).IDENTIFICATION_UPLOAD,
    file,
    {
      params: {
        type,
      },
    }
  );
};

export const uploadDeviceRepairImage = async (
  financeOrderId: string,
  file: FormData
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClientFile.post(
    M3_API().DEVICE_REPAIR_UPLOAD_IMAGE,
    file,
    {
      params: {
        financeOrderId,
      },
    }
  );
};

export const checkTranscribe = async (
  cartTag: string,
  numImages: number
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.put(
    M3_API(cartTag).IMAGE_TRANSCRIBE,
    {},
    {
      params: {
        cartTag,
        numImages,
      },
    }
  );
};
